import React from 'react';
import { useSelector } from 'react-redux';
import { getGameStateBadgeState } from '../store/selectors/gameStateBadgeSelector';
import GameStateBadge from '../GameStateBadge';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import badgeReducer from '../store/reducers/gameStateBadge';
import getBadgeLabel from '../utils/getBadgeLabel';

initContainerData.register({
    reducers: {
        gameStateBadge: badgeReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    routes: []
}];

const GameStateBadgeDataContainer = () => {
    const badgeState = useSelector(getGameStateBadgeState);
    const props = getBadgeLabel(badgeState);

    return (
        <GameStateBadge {...props} />
    );
};

export default GameStateBadgeDataContainer;
export { routes };
